import React from 'react'
import { ICONS } from '@Const/common'
import WizardFlowStep from '@Components/WizardFlow/wizard-flow-step'
import CreateWorkManualScene from '@Scenes/WorkScenes/CreateWorkManualScene'
import WizardCreateWorkNavigationBar from '@Scenes/WorkScenes/CreateWorkByWizardLayout/WizardCreateWorkNavigationBar'
import WorkDetailsStep from '@Scenes/WorkScenes/Steps/WorkDetailsStep'
import WritersStep from '@Scenes/WorkScenes/Steps/WritersSteps/WritersStep'
import PublishersStep from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep'
import RecordingsStep from '@Scenes/WorkScenes/Steps/RecordingsStep'
import ReviewWorkFormScene from '@Scenes/WorkScenes/ReviewWorkFormScene'
import SubmissionStep from '@Scenes/WorkScenes/Steps/SubmissionStep'
import WizardFlowStore from '@App/stores/wizardFlow/WizardFlowStore'

const createWizardFlow = (wizardFlowStore: WizardFlowStore): WizardFlowStep[] => [
    {
        stepIndicator: {
            icon: ICONS.search,
            label: 'Search',
        },
        forms: [<CreateWorkManualScene key="create-work-scene-step" />],
        navigationBar: <WizardCreateWorkNavigationBar />,
    },
    {
        stepIndicator: {
            icon: ICONS.workDetails,
            label: 'Enter Work Details',
        },
        forms: [<WorkDetailsStep key="work-details-step" />],
        navigationBar: <WizardCreateWorkNavigationBar />,
    },
    {
        stepIndicator: {
            icon: ICONS.writers,
            label: 'Add Writers',
        },
        forms: [<WritersStep key="writers-step" />],
        navigationBar: <WizardCreateWorkNavigationBar />,
    },
    {
        stepIndicator: {
            icon: ICONS.publishers,
            label: 'Add Publishers & Shares',
        },
        forms: [<PublishersStep key="publishers-step" />],
        navigationBar: <WizardCreateWorkNavigationBar />,
        onNextValidation: () => wizardFlowStore.workStore.onNextValidateOverclaim(),
    },
    {
        stepIndicator: {
            icon: ICONS.recordings,
            label: 'Add Recording',
        },
        forms: [<RecordingsStep key="recordings-step" />],
        navigationBar: <WizardCreateWorkNavigationBar />,
    },
    {
        stepIndicator: {
            icon: ICONS.workDetails,
            label: 'Review',
        },
        forms: [
            <ReviewWorkFormScene workType="create-wizard" key="edit-work-scene" />,
            <SubmissionStep key="submission-step" />,
        ],
        navigationBar: <WizardCreateWorkNavigationBar />,
        onNextValidation: () => wizardFlowStore.workStore.onNextValidateOverclaim(),
    },
]

export default createWizardFlow
